@let u = user();
<div class="mini-profile" (click)="$event.stopPropagation()">
  <header class="mini-profile__header">
    <div class="mini-profile__avatar">
      <andor-user-avatar [user]="u" [showStatus]="false" [showActivity]="true"></andor-user-avatar>
    </div>
    <div class="mini-profile__identity">
      <div class="mini-profile__name-row">
        <span
          #nameEl
          class="mini-profile__name"
          [andorTooltip]="displayName()"
          [tooltipDisabled]="!isNameTruncated(nameEl)">
          {{ displayName() }}
        </span>
        <span
          class="mini-profile__status-dot mini-profile__status-dot--{{ status() }}"
          [andorTooltip]="statusTooltip()"
          aria-hidden="false"
          [attr.aria-label]="statusTooltip()"></span>
        @if (role()) {
          <span class="mini-profile__role">{{ role() }}</span>
        }
      </div>
      @if (statusMessage()) {
        <div class="mini-profile__status-message" [andorTooltip]="statusMessage()">
          {{ statusMessage() }}
        </div>
      }
      @let joined = joinedLabel();
      @if (joined || inputMuted() || outputMuted()) {
        <div class="mini-profile__meta-row">
          @if (joined) {
            <span class="mini-profile__joined" [andorTooltip]="joinedTooltip()">
              <fa-icon [icon]="faClock"></fa-icon>
              <span>{{ joined }}</span>
            </span>
          }
          @if (inputMuted() || outputMuted()) {
            <span class="mini-profile__badges">
              @if (inputMuted() || outputMuted()) {
                <span class="mini-profile__badge" [andorTooltip]="'Microphone muted' | translate">
                  <fa-icon [icon]="faMicrophoneSlash"></fa-icon>
                </span>
              }
              @if (outputMuted()) {
                <span class="mini-profile__badge" [andorTooltip]="'Speakers muted' | translate">
                  <fa-icon [icon]="faVolumeSlash"></fa-icon>
                </span>
              }
            </span>
          }
        </div>
      }
    </div>
  </header>

  <div class="mini-profile__divider"></div>

  <section class="mini-profile__section">
    <andor-mat-slider-wrapper [label]="'Volume' | translate">
      <mat-slider [max]="2" [min]="0" [step]="0.01">
        <input
          matSliderThumb
          (valueChange)="updateVolume($event)"
          [value]="participantSettingsStore.getVolume$(u.id) | async" />
      </mat-slider>
    </andor-mat-slider-wrapper>
  </section>

  @if (permissionsStore.pokeUser$ | async) {
    <section class="mini-profile__section">
      <andor-text-field
        [formControl]="pokeControl"
        [label]="'Poke' | translate"
        [labelTooltip]="'Poke somebody to get his attention.' | translate"
        [placeholder]="'Are you around?' | translate"
        [errorMessages]="{ maxlength: 'Message is too long.' | translate }"
        [trailingButton]="pokeAction"></andor-text-field>
    </section>
  }

  <section class="mini-profile__section">
    <andor-text-field
      [formControl]="privateMessageControl"
      [label]="'Private Message' | translate"
      [labelTooltip]="'Send a direct message only this participant can see.' | translate"
      [placeholder]="'Send a private message...' | translate"
      [errorMessages]="{ maxlength: 'Message is too long.' | translate }"
      [trailingButton]="privateMessageAction"></andor-text-field>
  </section>

  @let isFavorite = participantSettingsStore.getIsFavourite$(u.id) | async;
  @let canMute = (permissionsStore.muteUser$ | async) ?? false;
  @let canKick = (permissionsStore.kickUser$ | async) ?? false;
  <div class="mini-profile__actions">
    <andor-square-icon-btn
      [variant]="isFavorite ? 'active' : 'default'"
      [tooltip]="(isFavorite ? 'Remove from Favorites' : 'Add to Favorites') | translate"
      (clicked)="toggleFavorite()">
      <fa-icon [icon]="isFavorite ? faStar : faStarRegular"></fa-icon>
    </andor-square-icon-btn>

    <andor-square-icon-btn
      [disabled]="!canMute"
      [tooltip]="
        (canMute
          ? 'Force-mute this participant. They will be notified.'
          : 'You do not have permission to mute participants.'
        ) | translate
      "
      (clicked)="sendMute()">
      <fa-icon [icon]="faMicrophoneSlash"></fa-icon>
    </andor-square-icon-btn>

    <andor-square-icon-btn
      [disabled]="maintenance.active() || !canKick"
      [tooltip]="
        (canKick ? 'Kick this participant.' : 'You do not have permission to kick participants.')
          | translate
      "
      (clicked)="kickParticipant()">
      <fa-icon [icon]="faUserSlash"></fa-icon>
    </andor-square-icon-btn>

    <andor-square-icon-btn
      variant="danger"
      [disabled]="maintenance.active() || !canKick"
      [tooltip]="
        (canKick
          ? 'Ban this participant for one year.'
          : 'You do not have permission to ban participants.'
        ) | translate
      "
      (clicked)="banParticipant()">
      <fa-icon [icon]="faBan"></fa-icon>
    </andor-square-icon-btn>
  </div>
</div>
